/**
 * Converts a string to a JavaScript type if it is just a stringified type
 * Example: "null" --> null, "asdf1234" --> "asdf1234"
 */

const stringToLiteral = value => {
  try {
    // eslint-disable-next-line no-new-func
    return new Function(`return ${value};`)();
  } catch (e) {
    return value;
  }
};

export default stringToLiteral;
